<template>
  <!-- 圖示選擇器：搜尋 + 分組面板，選到的值是本庫的圖示名 -->
  <el-popover
    v-model:visible="visible"
    :width="popoverWidth"
    trigger="click"
    placement="bottom-start"
    popper-class="icon-select-popper"
  >
    <template #reference>
      <el-input
        v-model="displayValue"
        readonly
        :placeholder="placeholder"
        class="icon-select-input"
      >
        <template #prefix>
          <svg-icon
            :name="modelValue || 'menu'"
            :class="['prefix-icon', { placeholder: !modelValue }]"
          />
        </template>
        <template #suffix>
          <el-icon v-if="modelValue" class="clear-btn" @click.stop="pick('')"
            ><CircleClose
          /></el-icon>
        </template>
      </el-input>
    </template>

    <div class="icon-select-panel">
      <el-input
        v-model="keyword"
        placeholder="搜尋圖示名稱"
        clearable
        size="small"
        class="search"
      />
      <el-scrollbar height="280px">
        <div v-for="group in filteredGroups" :key="group.key" class="group">
          <div class="group-title">{{ group.title }}</div>
          <div class="grid">
            <div
              v-for="name in group.names"
              :key="name"
              :class="['cell', { active: name === modelValue }]"
              :title="name"
              @click="pick(name)"
            >
              <svg-icon :name="name" size="20" />
              <span class="label">{{ name }}</span>
            </div>
          </div>
        </div>
        <el-empty v-if="!filteredGroups.length" description="找不到圖示" :image-size="60" />
      </el-scrollbar>
    </div>
  </el-popover>
</template>

<script setup>
import { computed, ref } from 'vue'
import { CircleClose } from '@element-plus/icons-vue'
import SvgIcon from './SvgIcon.vue'
import { ICON_GROUP_LIST } from '@/icons'

const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: '點選選擇圖示' },
  popoverWidth: { type: [String, Number], default: 460 }
})
const emit = defineEmits(['update:modelValue'])

const visible = ref(false)
const keyword = ref('')

const displayValue = computed(() => props.modelValue || '')

const filteredGroups = computed(() => {
  const kw = keyword.value.trim().toLowerCase()
  return ICON_GROUP_LIST.map((g) => ({
    ...g,
    names: kw ? g.names.filter((n) => n.includes(kw)) : g.names
  })).filter((g) => g.names.length)
})

function pick(name) {
  emit('update:modelValue', name)
  if (name) visible.value = false
}
</script>

<style scoped>
.icon-select-input :deep(.el-input__inner) {
  cursor: pointer;
}
.prefix-icon {
  font-size: 16px;
  color: var(--app-text-secondary, #606266);
}
.prefix-icon.placeholder {
  opacity: 0.35;
}
.clear-btn {
  cursor: pointer;
}
.search {
  margin-bottom: 8px;
}
.group-title {
  font-size: 12px;
  color: var(--app-text-muted, #909399);
  margin: 6px 0 4px;
  padding-left: 2px;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(84px, 1fr));
  gap: 4px;
}
.cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 8px 4px;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease;
}
.cell:hover {
  background: var(--el-color-primary-light-9);
  border-color: var(--el-color-primary-light-7);
}
.cell.active {
  background: var(--el-color-primary-light-9);
  border-color: var(--el-color-primary);
  color: var(--el-color-primary);
}
.label {
  font-size: 11px;
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
